import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      //cacheTime: 1000 * 60 * 60, // 1 hour
    },
  },
});

export default queryClient;